<template>
  <main class="layout">
    <filter-box
      ref="filterBox"
      tab="org"
      @add="$_modify"
      @search="$_search"
      @reset="$_reset"
    ></filter-box>
    <main class="table-box">
      <!-- 数据列表 -->
      <el-table
        class="table-list__box"
        ref="tableList"
        :data="dataList"
        :height="tableHeight"
        :rowClassName="$_getRowClass"
        v-loading="isLoading"
        border
        stripe
        tooltip-effect="dark"
      >
        <el-table-column label="操作" width="220" :resizable="false">
          <template slot-scope="scope">
            <el-button
              class="edit__btn"
              @click="$_modify(scope.$index, scope.row)"
              >编辑</el-button
            >
            <el-button class="delete__btn" @click="$_delete(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
        <el-table-column
          v-for="column in columns"
          :key="column.key"
          :prop="column.key"
          :label="column.label"
          :width="column.width"
          sortable
          show-overflow-tooltip
          filter-placement="bottom"
        ></el-table-column>
        <div class="table-list__empty" slot="empty">列表暂无数据</div>
      </el-table>
    </main>
    <!-- 分页 -->
    <div class="pagination__wrapper">
      <cd-pagination
        ref="pager"
        :total="pagination.total"
        :currPage="pagination.pageNow"
        :pageSize="pagination.pageSize"
        @changepage="$_changeCurrent"
        @changesize="$_changeSize"
        :explainShow="true"
        @refresh="$_getDataList"
      ></cd-pagination>
    </div>
    <modal-modify
      v-if="modal.show && modal.template === 'modal-modify'"
      :title="modal.title"
      :parentData="modal.data"
      path="org"
      @close="$_close"
      @success="$_successCallback"
    ></modal-modify>
  </main>
</template>

<script>
import FilterBox from "./../components/filter-box";
import resize from "@/mixins/resize";
import handlePagination from "@/mixins/handlePagination";
import ModalModify from "./../components/modal-modify";

export default {
  name: "mapping-org",
  mixins: [resize, handlePagination],
  data() {
    const columns = [
      { key: "platformName", label: "运营商", width: 160 },
      { key: "brandName", label: "品牌", width: 160 },
      { key: "sysName", label: "定制系统", width: 160 },
      { key: "supplierName", label: "供应商", width: 160 },
      { key: "uniqueName", label: "订阅名称", width: 160 },
      { key: "departmentId", label: "组织ID", width: 160 },
      { key: "mappingId", label: "映射ID", width: 160 },
      { key: "creator", label: "创建人", width: 120 },
      { key: "createTime", label: "创建时间", width: 180 },
      { key: "operator", label: "最后编辑人", width: 120 },
      { key: "updateTime", label: "最后编辑时间", width: 180 },
    ];
    return {
      isLoading: false,
      filter: {},
      dataList: [],
      columns,
      modal: {
        show: false,
        title: "",
        data: {},
        template: "",
      },
    };
  },
  methods: {
    $_reset(filter) {
      this.filter = { ...filter };
      this.pagination.pageNow = 1;
      this.pagination.pageSize = 20;
      this.$_getDataList();
    },
    // 搜索
    $_search(filter) {
      this.filter = { ...filter };
      this.pagination.pageNow = 1;
      this.$_getDataList();
    },
    // 获取数据列表
    $_getDataList() {
      let {
        sysType = "",
        supplierId = 0,
        uniqueName = "",
        departmentId = "",
        mappingId = "",
        platformKey = "",
        brandId = "",
      } = this.filter;
      let { pageNow = 1, pageSize = 20 } = this.pagination;
      this.$service
        .post("getDepartmentMappings", {
          sysType,
          supplierId,
          uniqueName,
          departmentId,
          mappingId,
          platformKey,
          brandId,
          pageNow,
          pageSize,
        })
        .then((result) => {
          if (result.$.checkResult(result, true)) {
            let { pages = 0, total = 0, rows = [] } = result.data;
            this.pagination.pages = pages;
            this.pagination.total = total;
            this.dataList = rows.splice(0);
          }
        });
    },
    $_getRowClass({ row, rowIndex }) {
      if (row.status === 2) {
        return "is-blocked";
      }
    },
    // 切换每页size
    $_changeSize(page, size) {
      this.pagination.pageSize = size;
      this.pagination.pageNow = 1;
      this.$_getDataList();
    },
    // 切换当前页
    $_changeCurrent(val) {
      this.pagination.pageNow = val;
      this.$_getDataList();
    },
    // 新增/编辑
    $_modify(index, row) {
      let action = "新增";
      if (index !== -1) {
        action = "编辑";
        this.modal.data = { ...row };
      }
      this.modal.template = "modal-modify";
      this.modal.title = `${action}组织映射`;
      this.modal.show = true;
    },
    // 删除按钮
    $_delete(row) {
      const self = this;
      let content = `
				<div>该映射信息将不可恢复，确认删除？</div>
			`;
      let { id } = row;
      $MessageBox.confirm({
        content,
        onOk() {
          self.$service
            .post("deleteDepartmentMapping", { id })
            .then((result) => {
              if (result.$.checkResult(result, true)) {
                $MessageBox.alert({
                  content: result.msg,
                  onOk() {
                    // todo 是否需要获取最新的筛选条件
                    // self.filter = Object.assign(self.$refs.filterBox.filter);
                    self.$_getDataList();
                  },
                });
              }
            });
        },
      });
    },
    // 弹窗成功回调
    $_successCallback() {
      this.$_close();
      this.$nextTick(() => {
        this.$_getDataList();
      });
    },
    // 关闭本页面发起的弹窗
    $_close() {
      this.modal.show = false;
      this.modal.template = "";
      this.modal.title = "";
      this.modal.data = {};
    },
  },
  mounted() {
    this.$refs["filterBox"] && this.$refs["filterBox"].$_search();
  },
  components: {
    FilterBox,
    ModalModify,
  },
};
</script>
<style lang="scss" scoped>
.layout {
  display: flex;
  flex: auto;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  height: 100%;
  border: 1px solid #eee;
}
.table-box {
  height: 100vh;
  border-top: 1px solid #eee;
  overflow-x: auto;
  position: relative;
}
</style>
